import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Sliders = () => {
    const [sliders, setSliders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [editing, setEditing] = useState(null);
    const [error, setError] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [formData, setFormData] = useState({
        title: '',
        subtitle: '',
        button_text: '',
        button_link: '',
        is_active: true,
        image_path: '',
        keep_image: true,
    });
    const [imageFile, setImageFile] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [useExistingImage, setUseExistingImage] = useState(false);
    const [availableImages, setAvailableImages] = useState([]);

    const API_BASE_URL = 'http://localhost:8000/api/admin';
    const API_STORAGE_URL = 'http://localhost:8000';

    useEffect(() => {
        fetchSliders();
        fetchAvailableImages();
    }, []);

    const fetchAvailableImages = async () => {
        try {
            const token = localStorage.getItem('admin_token');
            if (!token) return;

            const response = await axios.get(`${API_BASE_URL}/sliders/available-images`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Accept': 'application/json'
                }
            });
            setAvailableImages(response.data || []);
        } catch (error) {
            console.error('Error fetching available images:', error);
        }
    };

    const fetchSliders = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem('admin_token');
            
            if (!token) {
                setError('No authentication token found');
                setLoading(false);
                return;
            }

            const response = await axios.get(`${API_BASE_URL}/sliders`, {
                headers: { 
                    'Authorization': `Bearer ${token}`,
                    'Accept': 'application/json'
                }
            });
            
            console.log('Fetched sliders:', response.data);
            setSliders(response.data || []);
            setError('');
        } catch (error) {
            console.error('Error fetching sliders:', error);
            if (error.response?.status === 401) {
                setError('Session expired. Please login again.');
                localStorage.removeItem('admin_token');
                window.location.href = '/admin/login';
            } else {
                setError('Failed to load sliders: ' + (error.response?.data?.message || error.message));
            }
        } finally {
            setLoading(false);
        }
    };

    // FIXED: Get the correct image URL
    const getImageUrl = (imagePath) => {
        if (!imagePath) return null;
        
        console.log('Original image path:', imagePath);
        
        // For uploaded images (stored in storage)
        if (imagePath.startsWith('/storage/')) {
            const url = `http://localhost:8000${imagePath}`;
            console.log('Generated URL:', url);
            return url;
        }
        // For existing images in public folder
        else if (imagePath.startsWith('/images/')) {
            const url = `http://localhost:8000${imagePath}`;
            console.log('Generated URL:', url);
            return url;
        }
        // For full URLs
        else if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
            return imagePath;
        }
        // Fallback
        else {
            const url = `http://localhost:8000/${imagePath}`;
            console.log('Fallback URL:', url);
            return url;
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        setError('');

        try {
            const token = localStorage.getItem('admin_token');
            
            if (!formData.title.trim()) {
                setError('Title is required');
                setSubmitting(false);
                return;
            }

            let updateData = {
                title: formData.title.trim(),
                subtitle: formData.subtitle || '',
                button_text: formData.button_text || '',
                button_link: formData.button_link || '',
                is_active: formData.is_active ? 1 : 0,
            };

            let response;

            if (editing) {
                if (imageFile && !useExistingImage) {
                    const formDataToSend = new FormData();
                    Object.keys(updateData).forEach(key => {
                        formDataToSend.append(key, updateData[key]);
                    });
                    formDataToSend.append('image', imageFile);
                    
                    response = await axios.post(
                        `${API_BASE_URL}/sliders/${editing.id}?_method=PUT`,
                        formDataToSend,
                        {
                            headers: {
                                'Authorization': `Bearer ${token}`,
                                'Content-Type': 'multipart/form-data',
                                'Accept': 'application/json',
                            }
                        }
                    );
                } else if (useExistingImage && formData.image_path) {
                    updateData.image_path = formData.image_path;
                    response = await axios.put(
                        `${API_BASE_URL}/sliders/${editing.id}`,
                        updateData,
                        {
                            headers: {
                                'Authorization': `Bearer ${token}`,
                                'Content-Type': 'application/json',
                                'Accept': 'application/json',
                            }
                        }
                    );
                } else if (formData.keep_image) {
                    updateData.keep_image = true;
                    response = await axios.put(
                        `${API_BASE_URL}/sliders/${editing.id}`,
                        updateData,
                        {
                            headers: {
                                'Authorization': `Bearer ${token}`,
                                'Content-Type': 'application/json',
                                'Accept': 'application/json',
                            }
                        }
                    );
                } else {
                    updateData.remove_image = true;
                    response = await axios.put(
                        `${API_BASE_URL}/sliders/${editing.id}`,
                        updateData,
                        {
                            headers: {
                                'Authorization': `Bearer ${token}`,
                                'Content-Type': 'application/json',
                                'Accept': 'application/json',
                            }
                        }
                    );
                }
            } else {
                if (imageFile && !useExistingImage) {
                    const formDataToSend = new FormData();
                    Object.keys(updateData).forEach(key => {
                        formDataToSend.append(key, updateData[key]);
                    });
                    formDataToSend.append('image', imageFile);

                    response = await axios.post(
                        `${API_BASE_URL}/sliders`,
                        formDataToSend,
                        {
                            headers: {
                                'Authorization': `Bearer ${token}`,
                                'Content-Type': 'multipart/form-data',
                                'Accept': 'application/json',
                            }
                        }
                    );
                } else if (useExistingImage && formData.image_path) {
                    updateData.image_path = formData.image_path;
                    response = await axios.post(
                        `${API_BASE_URL}/sliders`,
                        updateData,
                        {
                            headers: {
                                'Authorization': `Bearer ${token}`,
                                'Content-Type': 'application/json',
                                'Accept': 'application/json',
                            }
                        }
                    );
                } else {
                    setError('Please select or upload an image');
                    setSubmitting(false);
                    return;
                }
            }

            await fetchSliders();
            resetForm();
            alert(editing ? 'Slider updated successfully!' : 'Slider created successfully!');
            
        } catch (error) {
            console.error('Error saving slider:', error);
            
            if (error.response) {
                if (error.response.status === 422) {
                    const errors = error.response.data.errors || {};
                    const messages = Object.values(errors).flat().join(', ');
                    setError(`Validation error: ${messages}`);
                } else {
                    setError(error.response.data?.message || `Error: ${error.response.status}`);
                }
            } else if (error.request) {
                setError('No response from server. Make sure the backend is running.');
            } else {
                setError(error.message);
            }
        } finally {
            setSubmitting(false);
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm('Are you sure you want to delete this slider?')) {
            try {
                const token = localStorage.getItem('admin_token');
                await axios.delete(`${API_BASE_URL}/sliders/${id}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                await fetchSliders();
                alert('Slider deleted successfully!');
            } catch (error) {
                console.error('Error deleting slider:', error);
                alert('Failed to delete slider: ' + (error.response?.data?.message || error.message));
            }
        }
    };

    const handleEdit = (slider) => {
        console.log('Editing slider:', slider);
        setEditing(slider);
        setFormData({
            title: slider.title || '',
            subtitle: slider.subtitle || '',
            button_text: slider.button_text || '',
            button_link: slider.button_link || '',
            is_active: slider.is_active === 1 || slider.is_active === true,
            image_path: slider.image_path || '',
            keep_image: true,
        });
        
        const imageUrl = getImageUrl(slider.image_path);
        console.log('Image URL for preview:', imageUrl);
        setImagePreview(imageUrl);
        setImageFile(null);
        setError('');
        setShowModal(true);
        
        const isPublicImage = slider.image_path && slider.image_path.startsWith('/images/');
        setUseExistingImage(isPublicImage);
    };

    const resetForm = () => {
        setFormData({
            title: '',
            subtitle: '',
            button_text: '',
            button_link: '',
            is_active: true,
            image_path: '',
            keep_image: true,
        });
        setImageFile(null);
        setImagePreview(null);
        setEditing(null);
        setShowModal(false);
        setError('');
        setSubmitting(false);
        setUseExistingImage(false);
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const validTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
            if (!validTypes.includes(file.type)) {
                setError('Please upload a valid image (JPEG, PNG, GIF, or WEBP)');
                return;
            }
            
            if (file.size > 5 * 1024 * 1024) {
                setError('Image size must be less than 5MB');
                return;
            }

            setImageFile(file);
            setUseExistingImage(false);
            setFormData({...formData, keep_image: false});
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result);
            };
            reader.readAsDataURL(file);
            setError('');
        }
    };

    const handleExistingImageSelect = (imagePath) => {
        setFormData({...formData, image_path: imagePath, keep_image: false});
        setImagePreview(getImageUrl(imagePath));
        setUseExistingImage(true);
        setImageFile(null);
        setError('');
    };

    if (loading) return <div style={{ padding: '40px', textAlign: 'center' }}>Loading sliders...</div>;

    return (
        <div style={{ padding: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <h2>Sliders Management ({sliders.length} sliders)</h2>
                <div style={{ display: 'flex', gap: '10px' }}>
                    <button onClick={fetchSliders} style={{ padding: '8px 16px', background: '#6b7280', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
                        🔄 Refresh
                    </button>
                    <button onClick={() => setShowModal(true)} style={{ padding: '8px 16px', background: '#124D1C', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
                        + Add New Slider
                    </button>
                </div>
            </div>

            {error && (
                <div style={{ background: '#fef2f2', color: '#dc2626', padding: '10px', borderRadius: '8px', marginBottom: '16px' }}>
                    <strong>Error:</strong> {error}
                    <button onClick={fetchSliders} style={{ marginLeft: '10px', padding: '4px 12px', background: '#dc2626', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
                        Retry
                    </button>
                </div>
            )}

            {sliders.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '40px', color: '#6b7a8f' }}>
                    <p>No sliders found. Click "Add New Slider" to create one.</p>
                </div>
            ) : (
                <table style={{ width: '100%', borderCollapse: 'collapse', background: 'white', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
                    <thead style={{ background: '#f9fafb' }}>
                        <tr>
                            <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e5e7eb' }}>Image</th>
                            <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e5e7eb' }}>Title</th>
                            <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e5e7eb' }}>Subtitle</th>
                            <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e5e7eb' }}>Button</th>
                            <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e5e7eb' }}>Status</th>
                            <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e5e7eb' }}>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sliders.map((slider) => {
                            // Generate the image URL
                            const imageUrl = getImageUrl(slider.image_path);
                            console.log(`Slider "${slider.title}" - Image URL:`, imageUrl);
                            
                            return (
                                <tr key={slider.id} style={{ borderBottom: '1px solid #e5e7eb' }}>
                                    <td style={{ padding: '12px' }}>
                                        {slider.image_path ? (
                                            <div style={{ width: '80px', height: '60px', position: 'relative' }}>
                                                <img 
                                                    src={imageUrl}
                                                    alt={slider.title}
                                                    style={{ 
                                                        width: '100%', 
                                                        height: '100%', 
                                                        objectFit: 'cover', 
                                                        borderRadius: '4px',
                                                        border: '1px solid #e5e7eb',
                                                        display: 'block'
                                                    }}
                                                    onError={(e) => {
                                                        console.error('❌ Image failed to load:', imageUrl);
                                                        console.error('Image path from DB:', slider.image_path);
                                                        e.target.style.display = 'none';
                                                        const parent = e.target.parentElement;
                                                        const span = document.createElement('span');
                                                        span.style.color = '#9ca3af';
                                                        span.textContent = 'No image';
                                                        parent.appendChild(span);
                                                    }}
                                                    onLoad={() => {
                                                        console.log('✅ Image loaded successfully:', imageUrl);
                                                    }}
                                                />
                                            </div>
                                        ) : (
                                            <span style={{ color: '#9ca3af' }}>No image</span>
                                        )}
                                    </td>
                                    <td style={{ padding: '12px', fontWeight: 'bold' }}>{slider.title}</td>
                                    <td style={{ padding: '12px' }}>{slider.subtitle || '-'}</td>
                                    <td style={{ padding: '12px' }}>{slider.button_text || '-'}</td>
                                    <td style={{ padding: '12px' }}>
                                        <span style={{
                                            padding: '4px 12px',
                                            borderRadius: '20px',
                                            fontSize: '0.85rem',
                                            background: slider.is_active ? '#dcfce7' : '#fee2e2',
                                            color: slider.is_active ? '#166534' : '#991b1b'
                                        }}>
                                            {slider.is_active ? 'Active' : 'Inactive'}
                                        </span>
                                    </td>
                                    <td style={{ padding: '12px' }}>
                                        <div style={{ display: 'flex', gap: '8px' }}>
                                            <button onClick={() => handleEdit(slider)} style={{ padding: '4px 12px', background: '#e5e7eb', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
                                                Edit
                                            </button>
                                            <button onClick={() => handleDelete(slider.id)} style={{ padding: '4px 12px', background: '#fee2e2', border: 'none', borderRadius: '4px', cursor: 'pointer', color: '#dc2626' }}>
                                                Delete
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            )}

            {/* Modal */}
            {showModal && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'rgba(0,0,0,0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 9999,
                    padding: '20px'
                }} onClick={() => resetForm()}>
                    <div style={{
                        background: 'white',
                        borderRadius: '12px',
                        padding: '30px',
                        maxWidth: '600px',
                        width: '100%',
                        maxHeight: '90vh',
                        overflowY: 'auto'
                    }} onClick={(e) => e.stopPropagation()}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                            <h2 style={{ margin: 0 }}>{editing ? 'Edit Slider' : 'Add New Slider'}</h2>
                            <button onClick={resetForm} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer' }}>×</button>
                        </div>
                        
                        <form onSubmit={handleSubmit}>
                            {error && (
                                <div style={{ background: '#fef2f2', color: '#dc2626', padding: '10px', borderRadius: '8px', marginBottom: '16px' }}>
                                    {error}
                                </div>
                            )}
                            
                            <div style={{ marginBottom: '16px' }}>
                                <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Title *</label>
                                <input
                                    type="text"
                                    value={formData.title}
                                    onChange={(e) => setFormData({...formData, title: e.target.value})}
                                    required
                                    placeholder="Enter slider title"
                                    style={{ width: '100%', padding: '10px', border: '1px solid #d1d5db', borderRadius: '8px' }}
                                />
                            </div>

                            <div style={{ marginBottom: '16px' }}>
                                <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Subtitle</label>
                                <input
                                    type="text"
                                    value={formData.subtitle}
                                    onChange={(e) => setFormData({...formData, subtitle: e.target.value})}
                                    placeholder="Brief description"
                                    style={{ width: '100%', padding: '10px', border: '1px solid #d1d5db', borderRadius: '8px' }}
                                />
                            </div>

                            <div style={{ marginBottom: '16px' }}>
                                <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Button Text</label>
                                <input
                                    type="text"
                                    value={formData.button_text}
                                    onChange={(e) => setFormData({...formData, button_text: e.target.value})}
                                    placeholder="Apply Now"
                                    style={{ width: '100%', padding: '10px', border: '1px solid #d1d5db', borderRadius: '8px' }}
                                />
                            </div>

                            <div style={{ marginBottom: '16px' }}>
                                <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Button Link</label>
                                <input
                                    type="text"
                                    value={formData.button_link}
                                    onChange={(e) => setFormData({...formData, button_link: e.target.value})}
                                    placeholder="/courses"
                                    style={{ width: '100%', padding: '10px', border: '1px solid #d1d5db', borderRadius: '8px' }}
                                />
                            </div>

                            <div style={{ marginBottom: '16px' }}>
                                <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Image Source</label>
                                <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                                    <label style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <input
                                            type="radio"
                                            checked={!useExistingImage}
                                            onChange={() => {
                                                setUseExistingImage(false);
                                                setFormData({...formData, image_path: '', keep_image: true});
                                                if (editing) {
                                                    setImagePreview(getImageUrl(editing.image_path));
                                                } else {
                                                    setImagePreview(null);
                                                }
                                            }}
                                        />
                                        Upload New Image
                                    </label>
                                    <label style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <input
                                            type="radio"
                                            checked={useExistingImage}
                                            onChange={() => setUseExistingImage(true)}
                                        />
                                        Use Existing Image
                                    </label>
                                    {editing && (
                                        <label style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                            <input
                                                type="radio"
                                                checked={!useExistingImage && !imageFile && formData.keep_image}
                                                onChange={() => {
                                                    setUseExistingImage(false);
                                                    setFormData({...formData, keep_image: true, image_path: ''});
                                                    setImagePreview(getImageUrl(editing.image_path));
                                                    setImageFile(null);
                                                }}
                                            />
                                            Keep Current Image
                                        </label>
                                    )}
                                </div>
                            </div>

                            {useExistingImage ? (
                                <div style={{ marginBottom: '16px' }}>
                                    <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Select Existing Image</label>
                                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '8px' }}>
                                        {availableImages.length === 0 ? (
                                            <div style={{ gridColumn: '1 / -1', textAlign: 'center', padding: '20px', color: '#6b7a8f' }}>
                                                No existing images found. Add images to backend/public/images/slider/
                                            </div>
                                        ) : (
                                            availableImages.map((img) => (
                                                <div 
                                                    key={img.path}
                                                    onClick={() => handleExistingImageSelect(img.path)}
                                                    style={{
                                                        border: formData.image_path === img.path ? '3px solid #124D1C' : '2px solid #e5e7eb',
                                                        borderRadius: '8px',
                                                        padding: '8px',
                                                        cursor: 'pointer',
                                                        textAlign: 'center',
                                                        background: formData.image_path === img.path ? '#f0f7f0' : 'white'
                                                    }}
                                                >
                                                    <img 
                                                        src={getImageUrl(img.path)} 
                                                        alt={img.name}
                                                        style={{ width: '100%', height: '60px', objectFit: 'cover', borderRadius: '4px' }}
                                                        onError={(e) => {
                                                            e.target.style.display = 'none';
                                                            e.target.parentElement.innerHTML = '<span style="color:#9ca3af;font-size:0.7rem;">No image</span>';
                                                        }}
                                                    />
                                                    <div style={{ fontSize: '0.6rem', marginTop: '4px', color: '#6b7a8f' }}>{img.name}</div>
                                                </div>
                                            ))
                                        )}
                                    </div>
                                    {formData.image_path && (
                                        <div style={{ marginTop: '8px', fontSize: '0.8rem', color: '#16a34a' }}>
                                            ✅ Selected: {formData.image_path}
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div style={{ marginBottom: '16px' }}>
                                    <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Upload New Image</label>
                                    <input
                                        type="file"
                                        accept="image/*"
                                        onChange={handleImageChange}
                                        style={{ width: '100%', padding: '8px' }}
                                    />
                                    <div style={{ fontSize: '0.8rem', color: '#6b7a8f', marginTop: '4px' }}>
                                        Accepted: JPEG, PNG, GIF, WEBP (Max 5MB)
                                    </div>
                                    {imagePreview && (
                                        <div style={{ marginTop: '10px' }}>
                                            <img src={imagePreview} alt="Preview" style={{ maxWidth: '200px', maxHeight: '200px', objectFit: 'cover', borderRadius: '8px' }} />
                                        </div>
                                    )}
                                </div>
                            )}

                            <div style={{ marginBottom: '16px' }}>
                                <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <input
                                        type="checkbox"
                                        checked={formData.is_active}
                                        onChange={(e) => setFormData({...formData, is_active: e.target.checked})}
                                    />
                                    Active
                                </label>
                            </div>

                            <div style={{ display: 'flex', gap: '16px' }}>
                                <button type="submit" disabled={submitting} style={{
                                    flex: 1,
                                    padding: '12px',
                                    background: '#124D1C',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '8px',
                                    cursor: submitting ? 'not-allowed' : 'pointer',
                                    opacity: submitting ? 0.6 : 1
                                }}>
                                    {submitting ? 'Saving...' : (editing ? 'Update Slider' : 'Create Slider')}
                                </button>
                                <button type="button" onClick={resetForm} style={{
                                    flex: 1,
                                    padding: '12px',
                                    background: 'transparent',
                                    border: '1px solid #e5e7eb',
                                    borderRadius: '8px',
                                    cursor: 'pointer'
                                }}>
                                    Cancel
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Sliders;